export default ['a', 'à', 'y'];
